import { defineMessages } from 'react-intl';

const scope = 'vendor.core.Translations';

export const phrasesMessages = defineMessages({
  hastiBazar: {
    id: `${scope}.hastiBazar`,
    defaultMessage: 'تپسی‌شاپ',
  },
  until: {
    id: `${scope}.until`,
    defaultMessage: 'الی',
  },
  postalTrackingCode: {
    id: `${scope}.postalTrackingCode`,
    defaultMessage: 'کد پیگیری پستی',
  },
  dartilVendor: {
    id: `${scope}.dartilVendor`,
    defaultMessage: 'تپسی‌شاپ - پنل فروشندگان',
  },
  emailOrPhoneNumber: {
    id: `${scope}.emailOrPhoneNumber`,
    defaultMessage: 'ایمیل یا شماره تلفن',
  },
  forgetPassword: {
    id: `${scope}.forgetPassword`,
    defaultMessage: 'فراموشی رمز عبور',
  },
  requiredField: {
    id: `${scope}.requiredField`,
    defaultMessage: 'این فیلد الزامی است',
  },
  emailOrPhoneNumberIsRequired: {
    id: `${scope}.emailOrPhoneNumberIsRequired`,
    defaultMessage: 'ایمیل یا شماره تلفن الزامی است',
  },
  submit: {
    id: `${scope}.submit`,
    defaultMessage: 'تایید',
  },

  forgetPasswordSubTitle: {
    id: `${scope}.forgetPasswordSubTitle`,
    defaultMessage: 'برای تغییر رمز عبور، شماره موبایل یا ایمیل خود را وارد کنید.',
  },
  nextLevel: {
    id: `${scope}.nextLevel`,
    defaultMessage: 'ادامه',
  },
  back: {
    id: `${scope}.back`,
    defaultMessage: 'بازگشت',
  },
  search: {
    id: `${scope}.search`,
    defaultMessage: 'جستجو ...',
  },
  login: {
    id: `${scope}.login`,
    defaultMessage: 'ورود',
  },
  loginSubTitle: {
    id: `${scope}.loginSubTitle`,
    defaultMessage: 'نام کاربری و رمز عبور خود را وارد نمایید.',
  },
  loginWithCode: {
    id: `${scope}.loginWithCode`,
    defaultMessage: 'ورود با رمزعبور یک‌بار مصرف',
  },
  justAllowNumbers: {
    id: `${scope}.justAllowNumbers`,
    defaultMessage: 'لطفا از اعداد فارسی یا انگلیسی استفاده نمایید.',
  },
  unavailable: {
    id: `${scope}.unavailable`,
    defaultMessage: 'ناموجود',
  },
  noOptionsText: {
    id: `${scope}.noOptionsText`,
    defaultMessage: 'موردی یافت نشد',
  },
  from: {
    id: `${scope}.from`,
    defaultMessage: 'از',
  },
  selectItem: {
    id: `${scope}.selectItem`,
    defaultMessage: 'یک مورد را انتخاب کنید',
  },
  none: {
    id: `${scope}.none`,
    defaultMessage: 'نامشخص',
  },
  waiting: {
    id: `${scope}.waiting `,
    defaultMessage: 'انتظار',
  },
  success: {
    id: `${scope}.success `,
    defaultMessage: 'موفق',
  },
  failed: {
    id: `${scope}.failed`,
    defaultMessage: 'ناموفق',
  },
  canceled: {
    id: `${scope}.canceled`,
    defaultMessage: 'انصراف',
  },
  awaitingPayment: {
    id: `${scope}.awaitingPayment`,
    defaultMessage: 'منتظر پرداخت',
  },
  canceledFromPayment: {
    id: `${scope}.canceledFromPayment`,
    defaultMessage: 'انصراف از پرداخت',
  },
  orderConfirmed: {
    id: `${scope}.orderConfirmed`,
    defaultMessage: 'تایید سفارش',
  },
  canceledOrder: {
    id: `${scope}.canceled`,
    defaultMessage: 'لغو سفارش',
  },
  canceledBySystem: {
    id: `${scope}.canceledBySystem`,
    defaultMessage: 'لغو سفارش سیستمی',
  },
  refunded: {
    id: `${scope}.refunded`,
    defaultMessage: 'مرجوع شده',
  },
  delivered: {
    id: `${scope}.delivered`,
    defaultMessage: 'تحویل کامل',
  },
  refundRequest: {
    id: `${scope}.refundRequest`,
    defaultMessage: 'درخواست مرجوعی',
  },
  awaitingCompletePayment: {
    id: `${scope}.awaitingCompletePayment`,
    defaultMessage: 'در انتظار تکمیل وجه',
  },
  in: {
    id: `${scope}.in`,
    defaultMessage: 'در',
  },
  to: {
    id: `${scope}.to`,
    defaultMessage: 'تا',
  },
  go: {
    id: `${scope}.go`,
    defaultMessage: 'برو',
  },
  goTo: {
    id: `${scope}.goTo`,
    defaultMessage: 'برو به ...',
  },
  aloPeyk: {
    id: `${scope}.aloPeyk`,
    defaultMessage: 'الوپیک',
  },
  aloNomic: {
    id: `${scope}.aloPeyk`,
    defaultMessage: 'الوپیک',
  },
  hastiOffline: {
    id: `${scope}.hastiOffline`,
    defaultMessage: 'هستی آفلاین',
  },
  sendMessage: {
    id: `${scope}.sendMessage`,
    defaultMessage: 'افزودن یادداشت',
  },

  downloadBarCode: {
    id: `${scope}.downloadBarCode`,
    defaultMessage: 'چاپ بارکد',
  },

  isRequired: {
    id: `${scope}.isRequired`,
    defaultMessage: 'اجباری می‌باشد',
  },
  noOptionFound: {
    id: `${scope}.noOptionFound`,
    defaultMessage: 'هیچ گزینه‌ای یافت نشد',
  },
  tehran: {
    id: `${scope}.tehran`,
    defaultMessage: 'تهران',
  },
  county: {
    id: `${scope}.county`,
    defaultMessage: 'شهرستان',
  },
  edit: {
    id: `${scope}.edit`,
    defaultMessage: 'ویرایش',
  },

  setting: {
    id: `${scope}.setting`,
    defaultMessage: 'تنظیمات',
  },
  create: {
    id: `${scope}.create`,
    defaultMessage: 'ایجاد',
  },
  delete: {
    id: `${scope}.delete`,
    defaultMessage: 'حذف',
  },
  deleteAll: {
    id: `${scope}.deleteAll`,
    defaultMessage: 'حذف همه',
  },
  copy: {
    id: `${scope}.copy`,
    defaultMessage: 'کپی کردن',
  },
  details: {
    id: `${scope}.details`,
    defaultMessage: 'جزئیات',
  },
  history: {
    id: `${scope}.history`,
    defaultMessage: 'تاریخچه',
  },
  import: {
    id: `${scope}.import`,
    defaultMessage: 'بارگذاری',
  },
  refresh: {
    id: `${scope}.refresh`,
    defaultMessage: 'به روزرسانی',
  },
  active: {
    id: `${scope}.active`,
    defaultMessage: 'فعال',
  },
  deActive: {
    id: `${scope}.deActive`,
    defaultMessage: 'غیرفعال',
  },
  download: {
    id: `${scope}.download`,
    defaultMessage: 'دریافت',
  },
  downloadAll: {
    id: `${scope}.downloadAll`,
    defaultMessage: 'دریافت همه',
  },
  public: {
    id: `${scope}.public`,
    defaultMessage: 'عمومی',
  },
  report: {
    id: `${scope}.report`,
    defaultMessage: 'گزارش گیری',
  },
  reportDaily: {
    id: `${scope}.reportDaily`,
    defaultMessage: 'گزارش گیری روزانه',
  },
  reportMonthly: {
    id: `${scope}.reportMonthly`,
    defaultMessage: 'گزارش گیری ماهانه',
  },
  id: {
    id: `${scope}.id`,
    defaultMessage: 'شناسه',
  },
  name: {
    id: `${scope}.name`,
    defaultMessage: 'نام',
  },
  lastName: {
    id: `${scope}.lastName`,
    defaultMessage: 'نام خانوادگی',
  },
  phoneNumber: {
    id: `${scope}.phoneNumber`,
    defaultMessage: 'شماره موبایل',
  },
  email: {
    id: `${scope}.email`,
    defaultMessage: 'ایمیل',
  },
  url: {
    id: `${scope}.url`,
    defaultMessage: 'آدرس وب',
  },
  dialogConfirmationTitle: {
    id: `${scope}.dialogConfirmationTitle`,
    defaultMessage: 'ذخیره کردن',
  },
  dialogConfirmationContent: {
    id: `${scope}.dialogConfirmationContent`,
    defaultMessage: 'آیا تمایل به ذخیره تغییرات دارید؟',
  },
  confirm: {
    id: `${scope}.confirm`,
    defaultMessage: 'تایید',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'انصراف',
  },
  noChoice: {
    id: `${scope}.noChoice`,
    defaultMessage: 'بدون انتخاب',
  },
  dashboard: {
    id: `${scope}.dashboard`,
    defaultMessage: 'داشبورد',
  },

  nextStep: {
    id: `${scope}.nextStep`,
    defaultMessage: 'مرحله بعد',
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'ذخیره',
  },
  saveSuccess: {
    id: `${scope}.saveSuccess`,
    defaultMessage: 'ذخیره کردن',
  },
  successDelete: {
    id: `${scope}.successDelete`,
    defaultMessage: 'با موفقیت حذف شد',
  },
  successAdd: {
    id: `${scope}.successAdd`,
    defaultMessage: 'با موفقیت اضافه شد',
  },
  successUpdate: {
    id: `${scope}.successUpdate`,
    defaultMessage: 'با موفقیت ویرایش شد',
  },
  loading: {
    id: `${scope}.loading`,
    defaultMessage: 'در حال دریافت اطلاعات ...',
  },
  informationHistory: {
    id: `${scope}.informationHistory`,
    defaultMessage: 'تاریخچه اطلاعات',
  },
  records: {
    id: `${scope}.records`,
    defaultMessage: 'سابقه',
  },
  close: {
    id: `${scope}.close`,
    defaultMessage: 'بستن',
  },
  view: {
    id: `${scope}.view`,
    defaultMessage: 'مشاهده',
  },
  home: {
    id: `${scope}.home`,
    defaultMessage: 'خانه',
  },
  password: {
    id: `${scope}.password`,
    defaultMessage: 'رمز عبور',
  },
  rejected: {
    id: `${scope}.rejected`,
    defaultMessage: 'رد شده',
  },
  accepted: {
    id: `${scope}.accepted`,
    defaultMessage: 'تایید شده',
  },
  published: {
    id: `${scope}.published`,
    defaultMessage: 'منتشر شده',
  },
  workflow: {
    id: `${scope}.workflow`,
    defaultMessage: 'گردش کار',
  },
  all: {
    id: `${scope}.all`,
    defaultMessage: 'همه',
  },
  draft: {
    id: `${scope}.draft`,
    defaultMessage: 'پیش نویس',
  },
  sendLink: {
    id: `${scope}.sendLink`,
    defaultMessage: 'ارسال لینک',
  },
  notSelected: {
    id: `${scope}.notSelected`,
    defaultMessage: 'انتخاب نشده',
  },
  release: {
    id: `${scope}.release`,
    defaultMessage: 'انتشار',
  },
  blocked: {
    id: `${scope}.blocked`,
    defaultMessage: 'مسدود',
  },
  searching: {
    id: `${scope}.searching`,
    defaultMessage: 'در حال جستجو ...',
  },
  previous: {
    id: `${scope}.previous`,
    defaultMessage: 'قبلی',
  },
  next: {
    id: `${scope}.next`,
    defaultMessage: 'بعدی',
  },
  add: {
    id: `${scope}.add`,
    defaultMessage: 'افزودن',
  },
  more: {
    id: `${scope}.more`,
    defaultMessage: 'بیشتر',
  },
  finalize: {
    id: `${scope}.finalize`,
    defaultMessage: 'نهایی کردن',
  },
  country: {
    id: `${scope}.country`,
    defaultMessage: 'کشور',
  },
  province: {
    id: `${scope}.province`,
    defaultMessage: 'استان',
  },
  district: {
    id: `${scope}.district`,
    defaultMessage: 'محله',
  },
  address: {
    id: `${scope}.address`,
    defaultMessage: 'آدرس',
  },
  city: {
    id: `${scope}.city`,
    defaultMessage: 'شهر',
  },
  role: {
    id: `${scope}.role`,
    defaultMessage: 'نقش',
  },
  plaque: {
    id: `${scope}.plaque`,
    defaultMessage: 'پلاک',
  },
  unit: {
    id: `${scope}.unit`,
    defaultMessage: 'واحد',
  },
  postalCode: {
    id: `${scope}.postalCode`,
    defaultMessage: 'کد پستی',
  },
  nationalCode: {
    id: `${scope}.nationalCode`,
    defaultMessage: 'کد ملی',
  },
  isDefault: {
    id: `${scope}.isDefault`,
    defaultMessage: 'پیش فرض',
  },
  deliverUser: {
    id: `${scope}.deliverUser`,
    defaultMessage: 'گیرنده سفارش خودم هستم',
  },
  title: {
    id: `${scope}.title`,
    defaultMessage: 'عنوان',
  },
  instagram: {
    id: `${scope}.instagram`,
    defaultMessage: 'اینستاگرام',
  },
  whatsapp: {
    id: `${scope}.whatsapp`,
    defaultMessage: 'واتس آپ',
  },
  linkedin: {
    id: `${scope}.linkedin`,
    defaultMessage: 'لینکدین',
  },
  doCopy: {
    id: `${scope}.doCopy`,
    defaultMessage: 'کپی کردن',
  },
  dialogConfirmationCopy: {
    id: `${scope}.dialogConfirmationCopy`,
    defaultMessage: 'آیا از کپی کردن این آدرس مطمئن هستید ؟',
  },
  dialogConfirmationDelete: {
    id: `${scope}.dialogConfirmationDelete`,
    defaultMessage: 'آیا از حذف کردن این آدرس مطمئن هستید ؟',
  },
  yes: {
    id: `${scope}.yes`,
    defaultMessage: 'بله',
  },
  no: {
    id: `${scope}.no`,
    defaultMessage: 'خیر',
  },
  ngeState: {
    id: `${scope}.changeState`,
    defaultMessage: 'تغییر مرحله',
  },
  currentState: {
    id: `${scope}.currentState`,
    defaultMessage: 'مرحله جاری',
  },
  roleStateChanged: {
    id: `${scope}.roleStateChanged`,
    defaultMessage: 'گردش کار نقش با موفقیت تغییر یافت',
  },
  noData: {
    id: `${scope}.noData`,
    defaultMessage: 'دیتایی وجود ندارد',
  },
  reloadSetting: {
    id: `${scope}.reloadSetting`,
    defaultMessage: 'بارگذاری مجدد تنظیمات',
  },
  fullScreen: {
    id: `${scope}.fullScreen`,
    defaultMessage: 'نمایش کامل',
  },
  admin: {
    id: `${scope}.admin`,
    defaultMessage: 'ادمین',
  },
  uploadImageFile: {
    id: `${scope}.uploadImageFile`,
    defaultMessage: 'آپلود تصویر',
  },
  showMore: {
    id: `${scope}.showMore`,
    defaultMessage: 'مشاهده جزئیات',
  },
  status: {
    id: `${scope}.status`,
    defaultMessage: 'وضعیت',
  },
  statusItem: {
    id: `${scope}.statusItem`,
    defaultMessage: 'وضعیت آیتم',
  },
  resetFilter: {
    id: `${scope}.resetFilter`,
    defaultMessage: 'حذف فیلتر',
  },
  filtering: {
    id: `${scope}.filtering`,
    defaultMessage: 'اعمال فیلتر',
  },
  notAuthorized: {
    id: `${scope}.notAuthorized`,
    defaultMessage: 'شما دسترسی لازم برای انجام این عملیات را ندارید',
  },
  recordHistory: {
    id: `${scope}.recordHistory`,
    defaultMessage: 'جزئیات تغییرات رکورد',
  },
  saturday: {
    id: `${scope}.saturday`,
    defaultMessage: 'شنبه',
  },
  sunday: {
    id: `${scope}.sunday`,
    defaultMessage: 'یک شنبه',
  },
  monday: {
    id: `${scope}.monday`,
    defaultMessage: 'دو شنبه',
  },
  tuesday: {
    id: `${scope}.tuesday`,
    defaultMessage: 'سه شنبه',
  },
  wednesday: {
    id: `${scope}.wednesday`,
    defaultMessage: 'چهار شنبه',
  },
  thursday: {
    id: `${scope}.thursday`,
    defaultMessage: 'پنج شنبه',
  },
  friday: {
    id: `${scope}.friday`,
    defaultMessage: 'جمعه',
  },
  date: {
    id: `${scope}.date`,
    defaultMessage: 'تاریخ',
  },

  rial: {
    id: `${scope}.rial`,
    defaultMessage: 'ریال',
  },
  toman: {
    id: `${scope}.toman`,
    defaultMessage: 'تومان',
  },
  number: {
    id: `${scope}.number`,
    defaultMessage: 'عدد',
  },
  downloadAddGroupTemplate: {
    id: `${scope}.downloadAddGroupTemplate`,
    defaultMessage: 'دریافت قالب افزودن گروهی محصول',
  },
  changeStatus: {
    id: `${scope}.changeStatus`,
    defaultMessage: 'تغییر وضعیت',
  },
  reasonReturnItem: {
    id: `${scope}.reasonReturnItem`,
    defaultMessage: 'دلیل عدم تحویل آیتم',
  },
  notfound: {
    id: `${scope}.notfound`,
    defaultMessage: 'نتیجه ای یافت نشد.',
  },
  saveDraft: {
    id: `${scope}.saveDraft`,
    defaultMessage: 'ذخیره کالا به عنوان پیش نویس',
  },
  viewAll: {
    id: `${scope}.viewAll`,
    defaultMessage: 'نمایش همه',
  },
  assignVoucher: {
    id: `${scope}.assignVoucher`,
    defaultMessage: 'اعمال تخفیف',
  },
  registerSucceed: {
    id: `${scope}.registerSucceed`,
    defaultMessage: 'ثبت شد',
  },
  unexpectederror: {
    id: `${scope}.unexpectederror`,
    defaultMessage: 'مشکلی در سرور به وجود آمده است',
  },
  total: {
    id: `${scope}.total`,
    defaultMessage: 'مجموع',
  },
  range: {
    id: `${scope}.range`,
    defaultMessage: 'بازه',
  },
  uploadFile: {
    id: `${scope}.uploadFile`,
    defaultMessage: 'فایل را آپلود کنید.',
  },
  has: {
    id: `${scope}.has`,
    defaultMessage: 'دارد',
  },
  notHas: {
    id: `${scope}.notHas`,
    defaultMessage: 'ندارد',
  },
  getDataError: {
    id: `${scope}.getDataError`,
    defaultMessage: 'خطا در دریافت اطلاعات',
  },
  retry: {
    id: `${scope}.retry`,
    defaultMessage: 'تلاش مجدد',
  },
  lastStep: {
    id: `${scope}.lastStep`,
    defaultMessage: 'مرحله قبل',
  },
  register: {
    id: `${scope}.register`,
    defaultMessage: 'ثبت',
  },
  finalRegister: {
    id: `${scope}.finalRegister`,
    defaultMessage: 'ثبت نهایی',
  },
  productCategory: {
    id: `${scope}.productCategory`,
    defaultMessage: 'گروه کالا',
  },
  forContinueClickOnNextStep: {
    id: `${scope}.forContinueClickOnNextStep`,
    defaultMessage: 'برای ادامه روی مرحله بعد کلیک کنید',
  },
  noItemFound: {
    id: `${scope}.noItemFound`,
    defaultMessage: 'موردی یافت نشد',
  },
  minute: {
    id: `${scope}.minute`,
    defaultMessage: 'دقیقه',
  },
  totalCount: {
    id: `${scope}.totalCount`,
    defaultMessage: 'تعداد کل',
  },
  rowsNumber: {
    id: `${scope}.rowsNumber`,
    defaultMessage: 'تعداد سطر',
  },
  wrongFormat: {
    id: `${scope}.wrongFormat`,
    defaultMessage: 'فرمت {msg} درست نمی‌باشد',
  },
  enteredFieldAreInvalid: {
    id: `${scope}.enteredFieldAreInvalid`,
    defaultMessage: 'فیلدهای وارد شده نامعتبر می‌باشد',
  },
  technicalDocumentation: {
    id: `${scope}.technicalDocumentation`,
    defaultMessage: 'مستندات فنی',
  },
  minimumSizeAllowedForProductImg: {
    id: `${scope}.minimumSizeAllowedForProductImg`,
    defaultMessage: 'حداقل سایز مجاز برای عرض و ارتفاع تصویر ۹۳۶ در ۹۳۶ می‌باشد',
  },
  ratioAllowedForProductImg: {
    id: `${scope}.ratioAllowedForProductImg`,
    defaultMessage:
      'نسبت طول و عرض تصویر مجاز برای بارگذاری یک می‌باشد. به عبارت دیگر تصویر باید مربعی باشد.',
  },
  pasteImageErrorMessage: {
    id: `${scope}.pasteImageErrorMessage`,
    defaultMessage: 'تصویر حذف شده است. برای افزودن تصویر، لطفاً از نوار ابزار بالا آپلود کنید.',
  },
  pasteVideoErrorMessage: {
    id: `${scope}.pasteVideoErrorMessage`,
    defaultMessage: 'ویدئو حذف شده است. برای افزودن ویدئو، لطفاً از نوار ابزار بالا آپلود کنید.',
  },
  videoSizeEditor: {
    id: `${scope}.videoSizeEditor`,
    defaultMessage: 'حجم ویدیو  از ۳ مگابایت نباید بیشتر باشد.',
  },
  ratioVideoEditor: {
    id: `${scope}.ratioVideoEditor`,
    defaultMessage: 'نسبت تصویر ویدئو باید ۲.۲۱ : ۱ باشد.',
  },
  onlyMediaErrorMessage: {
    id: `${scope}.onlyMediaErrorMessage`,
    defaultMessage: 'معرفی نمی‌تواند فقط شامل عکس یا ویدیو باشد.',
  },
  ratioLogoStore: {
    id: `${scope}.ratioLogoStore`,
    defaultMessage: 'طول و عرض لوگوی فروشگاه یکسان نمی‌باشد.',
  },
  maxAndMinWidthLogo: {
    id: `${scope}.maxAndMinWidthLogo`,
    defaultMessage: 'طول و عرض لوگو باید بین ۵۰۰ تا ۳۰۰۰ پیکسل باشد.',
  },
  accessDenied: {
    id: `${scope}.accessDenied`,
    defaultMessage: 'دسترسی غیرمجاز',
  },
  accessDeniedDes: {
    id: `${scope}.accessDeniedDes`,
    defaultMessage: 'شما مجوز دسترسی به این صفحه را ندارید.',
  },
  beckToDashboard: {
    id: `${scope}.beckToDashboard`,
    defaultMessage: 'بازگشت به داشبورد',
  },
  valid: {
    id: `${scope}.valid`,
    defaultMessage: 'معتبر',
  },
  inValid: {
    id: `${scope}.inValid`,
    defaultMessage: 'نامعتبر',
  },
  successfullyDone: {
    id: `${scope}.successfullyDone`,
    defaultMessage: 'با موفقیت انجام شد',
  },
  row: {
    id: `${scope}.row`,
    defaultMessage: 'ردیف',
  },
});
